type ClassObject = {
  [key: string]: boolean
}

export function classnames(...args: (ClassObject | string)[]): string {
  if (args.length === 1 && typeof args[0] === 'object') {
    const classes = args[0] as ClassObject
    return Object.keys(classes)
      .filter((className) => classes[className])
      .join(' ')
  } else {
    return args.filter((className) => !!className).join(' ')
  }
}
